window.addEventListener('DOMContentLoaded', function() {
    (function($) {
    
      // jQuery plugin to get URL parameter
      $.urlParam = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null) {
          return null;
        }
        else {
          return decodeURI(results[1]) || 0;
        }
      }
      
      
      var urlParams = new URLSearchParams(window.location.search);
      
      if (urlParams.has('tumbler')) {
        // do something
        console.log('it exists')
        var id = $.urlParam('tumbler');
        if(id=='free'){
          console.log('its free')
           $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                  id:43090030657695,
                  quantity:1,
                  discount_code:'10PLUSTB'
              },
              dataType: 'json',
              success: function() {
                // Update the cart count and show a success message
                console.log("added tumbler buddy")
                
                $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  data: {
                    quantity: 1,
                    id: '43090030657695'
                  },
                  dataType: 'json',
                  success: function(data) {
                    console.log("update cart")
                    window.location.href = '/';
                    // Refresh the cart information on the page
                    // For example, you could update the cart count in the header
                  }
                });
              },
              error: function() {
                // Show an error message
                $('.error-message').fadeIn().delay(2000).fadeOut();
              }
            });
        }
        
      }

    
          
    })(jQuery);
  });
